import enFallback from './en-fallback/omnea-app.json'

export const i18nextFallbackResources = {
  ...enFallback,
} as const
export const defaultNS = 'common'
